import { ResourceFile } from '@/models/ResourceFile';
import { getField, updateField } from 'vuex-map-fields';
import { httpError } from '@/models/httpError';
import { HTTP } from '@/http-common';
const state = {
  rows: [],
  message: new httpError(),
};

//getters

const getters = {
  getField,
};

//Mutations
const mutations = {
  setResourceFiles(state, resourceFiles) {
    // state.rows.length = 0;
    state.rows = resourceFiles;
  },
  addRow(state) {
    if (state.rows.length > 0) {
      state.rows.push(new ResourceFile());
    } else {
      state.rows = [new ResourceFile()];
    }
  },
  deleteRow(state) {
    // To enable multi-row form handling
    // we make it possible to add new rows.
    state.rows.pop();
  },
  setProgress(state, message) {
    state.message = message;
  },
  removeRow(state, index) {
    state.rows.splice(index, 1);
  },
  updateField,
};

//ACTIONS
const actions = {
  reset({ commit }) {
    commit('setResourceFile', [
      new ResourceFile({ licenses: state.fields, product: 'insight' }),
    ]);
  },
  addResource({ state, commit }) {
    return new Promise((resolve) => {
      commit('addRow');
      resolve(state.rows.length - 1);
    });
  },
  async getResourceFiles({ commit, dispatch }, showArchived) {
    try {
      var order = await HTTP.get(
        `DealerPortal/GetResourceFiles/${showArchived}`
      );
      if (order.status != 200) {
        dispatch('reset');
      } else;
      dispatch(
        'setMessage',
        new httpError({ message: 'Retreived OK', httpStatus: 200 })
      );
      return Promise.resolve(order.data);
    } catch (err) {
      dispatch(
        'setMessage',
        new httpError({
          message: 'Error getting ResourceFile:' + err,
          httpStatus: 500,
        })
      );
      return Promise.reject(err);
    }
  },
  async getResourceFilesAsTree({ commit, dispatch }, showArchived) {
    try {
      var order = await HTTP.get(
        `DealerPortal/GetResourceFilesAsTree/${showArchived}`
      );
      if (order.status != 200) {
        dispatch('reset');
      } else;
      dispatch(
        'setMessage',
        new httpError({ message: 'Retreived OK', httpStatus: 200 })
      );
      return Promise.resolve(order.data);
    } catch (err) {
      dispatch(
        'setMessage',
        new httpError({
          message: 'Error getting ResourceFile:' + err,
          httpStatus: 500,
        })
      );
      return Promise.reject(err);
    }
  },
  async saveResourceFile({ dispatch, state }, index) {
    try {
      var order = await HTTP.post(
        'DealerPortal/UpdateResourceFiles/',
        state.rows[index]
      );
      dispatch(
        'setMessage',
        new httpError({ message: 'saved OK', httpStatus: 200 })
      );
      return Promise.resolve(order.data);
    } catch (err) {
      dispatch(
        'setMessage',
        new httpError({ message: 'unable to save:' + err, httpStatus: 500 })
      );
      return Promise.reject(err);
    }
  },
  async removeRows({ state, commit }, index) {
    try {
      var ResourceFiles = await HTTP.delete(
        'DealerPortal/DeleteResourceFiles/',
        {
          data: [state.rows[index]],
        }
      );
      commit('removeRow', index);
      return Promise.resolve(ResourceFiles);
    } catch (e) {
      return Promise.reject(e);
    }
  },
  setMessage({ commit }, message) {
    commit('setProgress', message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit('setProgress', new httpError());
      }, 2000);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
